import React from "react"

const ProCardSkeleton = ({ mobile = false }) => (
  <div
    className={`flex flex-col items-start gap-3 ${
      mobile ? "min-w-[152px] max-w-[286px]" : "min-w-[152px] max-w-[286px] flex-1"
    }`}>
    {/* Image skeleton */}
    <div className="relative w-full shrink-0 overflow-hidden rounded-[16px]">
      <div className="aspect-[160/128] w-full animate-pulse bg-[#E4EFF6]" />
    </div>
    {/* Content skeleton */}
    <div className="flex w-full flex-col items-start gap-1">
      <div className="h-[20px] w-full animate-pulse rounded bg-gray-light" />
      <div className="h-[20px] w-3/4 animate-pulse rounded bg-gray-light" />
      <div className="h-[16px] w-1/2 animate-pulse rounded bg-gray-light" />
      <div className="h-[16px] w-2/3 animate-pulse rounded bg-gray-light" />
    </div>
  </div>
)

export default ProCardSkeleton
